var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgAttachFileIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 12.548 11.048",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "np_attach_4079291_000000",
    d: "M14.2,11.109a3.884,3.884,0,0,1,2.763,1.137A3.8,3.8,0,0,1,18.1,14.965a3.872,3.872,0,0,1-1.138,2.779l-3.874,3.847a.573.573,0,0,1-.406.168.578.578,0,0,1-.408-.988l3.872-3.846a2.724,2.724,0,0,0,.8-1.954,2.649,2.649,0,0,0-.794-1.9,2.829,2.829,0,0,0-3.893,0L7.225,18.1l-.02.02a1.685,1.685,0,0,0,0,2.382,1.678,1.678,0,0,0,2.383,0L14.194,15.9l.019-.02a.6.6,0,0,0,.174-.431.527.527,0,0,0-.161-.379.613.613,0,0,0-.862-.012l-2.152,2.152a.578.578,0,0,1-.818-.818l2.151-2.151a1.808,1.808,0,0,1,2.486,0,1.658,1.658,0,0,1,.511,1.193,1.76,1.76,0,0,1-.483,1.236l-.027.029-4.625,4.626a2.842,2.842,0,0,1-2.02.835H8.364a2.766,2.766,0,0,1-1.982-.841,2.844,2.844,0,0,1-.019-3.987l.025-.026,5.055-5.056A3.878,3.878,0,0,1,14.2,11.109Z",
    transform: "matrix(1, 0, 0, 1, -5.556, -11.109)",
    fill: "#5636d0"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgAttachFileIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/attach-file-icon.9394237b.svg";
export { ForwardRef as ReactComponent };